import { Box } from '@mui/material'
import Footer from '../../components/Footer'
import DamageDuringRoute from '../../components/DamageDuringRoute'

import { useParamsFromURL } from '../../hooks/useParamsFromURL'
import MainBody from './MainBody'
import MainHeader from './MainHeader'
import { LayoutFor } from '../../types'

const MainPage = () => {
  // Custom hooks
  const { preview, layoutFor = LayoutFor.DAMAGE_REGISTRATION } =
    useParamsFromURL(['preview', 'layoutFor'])
  const isDamageDuringRoute = layoutFor === LayoutFor.DAMAGE_DURING_ROUTE
  const shouldShowFooter = !(
    preview ||
    layoutFor === LayoutFor.IN_ROUTE ||
    isDamageDuringRoute
  )

  return (
    <Box
      sx={{
        py: isDamageDuringRoute ? 0 : 13,
      }}
      width="100%"
    >
      <MainHeader layoutFor={layoutFor as LayoutFor} />
      {isDamageDuringRoute ? (
        <DamageDuringRoute />
      ) : (
        <MainBody preview={preview} layoutFor={layoutFor as LayoutFor} />
      )}
      {shouldShowFooter && <Footer />}
    </Box>
  )
}

export default MainPage
